import { useState } from 'react';
import { buildApiUrl } from '../config/environment';

interface ContactFormData {
  name: string;
  email: string;
  subject: string;
  message: string;
}

interface UseContactFormProps {
  isAuthenticated: boolean;
  user: { id: number; username: string } | null;
  onSuccess?: () => void;
}

export const useContactForm = ({ isAuthenticated, user, onSuccess }: UseContactFormProps) => {
  const [contactForm, setContactForm] = useState<ContactFormData>({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  
  const [contactStatus, setContactStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

  const handleContactSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setContactStatus('sending');
    
    try {
      const response = await fetch(buildApiUrl('/api/contact'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          ...contactForm,
          userId: isAuthenticated ? user?.id : null,
          username: isAuthenticated ? user?.username : null
        })
      });
      
      if (response.ok) {
        setContactStatus('success');
        setContactForm({ name: '', email: '', subject: '', message: '' });
        setTimeout(() => {
          setContactStatus('idle');
          if (onSuccess) {
            onSuccess();
          }
        }, 2000);
      } else {
        setContactStatus('error');
      }
    } catch (error) {
      console.error('Error sending contact form:', error);
      setContactStatus('error');
    }
  };

  const resetForm = () => {
    setContactForm({ name: '', email: '', subject: '', message: '' });
    setContactStatus('idle');
  };

  return {
    contactForm,
    setContactForm,
    contactStatus,
    handleContactSubmit,
    resetForm
  };
};